import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Grid } from '@xsolla/ui-core';

import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { MFAIcon, OAuth2Icon, SignatureIcon, ToggleBox } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';

const SecureSettings = ({ match }: RouteComponentProps): JSX.Element => {
  const { mfaPath, oauthPath, signaturePath } = usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  return (
    <>
      <ToggleBox
        title={intl.messages['navigation.settings.secure.label']}
        dataTestId="navigation-block-security"
        openByDefault>
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            dataTestId="link-navigation-oauth2"
            icon={<OAuth2Icon />}
            titleInfo={{
              label: intl.messages['navigation.settings.secure.oauth2.title'],
              path: oauthPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.secure.oauth2.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-signature"
            icon={<SignatureIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.secure.signature.title'],
              path: signaturePath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.secure.signature.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-mfa-policy"
            icon={<MFAIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.secure.multi-factor.title'],
              path: mfaPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.secure.multi-factor.subtitle']}
          />
        </Grid>
      </ToggleBox>
    </>
  );
};

export default withRouter(SecureSettings);
